import { mainHeaderId } from "@Constants/PortalConstants";

export const scrollToY = (position: number): void => {
    window.scrollTo({
        top: position,
        behavior: "smooth",
    });
};

export const getHeaderHeight = (): number => {
    const menuHeight = document.getElementById(mainHeaderId)?.clientHeight || 0;
    const campaignBarHeight = document.getElementById("campaignBar")?.clientHeight || 0;

    return menuHeight + campaignBarHeight;
};

export const jumpToSectionElement = (
    element: HTMLElement,
    forceJump: boolean = false,
    scrollOffset: number = 0,
    behavior: ScrollBehavior = "smooth",
) => {
    if (element) {
        const { top, bottom } = element.getBoundingClientRect();
        if (forceJump || top < 0 || bottom > window.innerHeight) {
            const position = top + window.scrollY - getHeaderHeight() - scrollOffset;
            window.scrollTo({ top: position, behavior });
        }
    }
};

export const jumpToSectionId = (
    scrollToId: string,
    forceJump: boolean = false,
    scrollOffset = 0,
    behavior: ScrollBehavior = "smooth",
) => {
    const element = document.getElementById(scrollToId);
    jumpToSectionElement(element, forceJump, scrollOffset, behavior);
};
